import { ObservationsService } from "./../../Services/observations.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-observation-card",
  templateUrl: "./observation-card.component.html",
  styleUrls: ["./observation-card.component.scss"],
})
export class ObservationCardComponent implements OnInit {
  @Input() index: number;
  @Input() observationId: string;
  @Input() checksAccions: any;
  @Input() checksIndications: any;
  @Output() increaseNumbObservation = new EventEmitter<string>();
  public noteData: any = {
    i_ant_pac: false,
    i_ant_asept: false,
    i_desp_fc: false,
    i_desp_pac: false,
    i_desp_asept: false,
    a_fm: false,
    a_lm: false,
    a_omision: false,
    a_guantes: false,
  };
  public radioData: any = {};
  public showGifSuccess: boolean = false;
  public showRadio: boolean = false;
  public accionRadio: any;
  public listprofessionalProfile:any;

  public professionalProfileSelect: any = {
    Nursing: ["Enfermera", "Matrona", "EIR", "Estudiante"],
    Medicine: ["Médico", "Pediatra", "MIR", "Estudiante"],
    SanitaryTechnician: [
      "Técnico de cuidados (TCAE)",
      "Técnico rayos (TER)",
      "Técnico laboratorio (TEL)",
      "Higienista salud bucodental",
      "Estudiante",
    ],
    Physiotherapy: ["Fisioterapeuta", "Estudiante"],
    Odontology: ["Odontólogo", "Estudiante"],
    Watchman: ["Celador"],
    Others: [
      "Farmacéutico",
      "Trabajador social",
      "Logopeda",
      "Terapeuta ocupacional",
    ],
  };
  //////////////
  ///cardForm
  //////////////
  public profesional_category: string = "";
  public code: string = "";
  constructor(
    private observationService: ObservationsService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    console.log('this.checksAccions');
    console.log(this.checksAccions);
  }

  public sendObservationNote() {
    let note = {
      ...this.noteData,
      ...this.radioData,
      profesional_category: this.profesional_category,
      code: this.code,
    };

    for (const key in note) {
      if (typeof note[key] !== "string") {
       
        if (note[key] == false) {
          note[key] = 0;
        } else {
          note[key] = 1;
        }
        
      }
    }
    if (note['a_ambos']==true){
      note['a_fm']=1;
      note['a_lm']=1;
    }

    let verifyNote: any = [];
    for (const key in note) {
      if (typeof note[key] !== "string") {
        verifyNote.push(note[key]);
      }
    }

    let validateIndicationsAndAccions = verifyNote.some((element, index) => {
      return element == 1;
    });

   console.log('validateIndicationsAndAccions',validateIndicationsAndAccions)
   console.log(' note', note['a_omision'])
 
    if (!validateIndicationsAndAccions) {
      this.toaster.error(
        "Es necesario seleccionar una acción"
      );
      return;
    }

    if (note['a_omision']){
      console.log('aca va el codigo',this.noteData)
      if (this.noteData['i_ant_asept']==0&&this.noteData['i_ant_pac']==0
        &&this.noteData['i_desp_asept']==0&&this.noteData['i_desp_fc']==0
        &&this.noteData['i_desp_pac']==0)
        {
          this.toaster.error(
            "Es necesario seleccionar una indicación"
          );
          return;
        }
      

      

      

      

      

    }
    if (this.profesional_category === "" || this.code === "") {
      this.toaster.error(
        "Es necesario seleccionar un campo y perfil profesional"
      );
      return;
    }
    if (note['a_fm']==0&&note['a_lm']==0&&note['a_guantes']==0&&note['a_omision']==0){
      this.toaster.error(
        "Es necesario seleccionar una acción"
      );
      return;
    }
    
    
    this.observationService
      .addNote(this.observationId, note)
      .then((resp) => {
        if (resp.status == "success") {
          this.showGifSuccess = true;
          setTimeout(() => {
            this.showGifSuccess = false;
          }, 3000);
          this.increaseNumbObservation.emit();
          this.refresh();
        }
        if (resp.status == "error") {
          this.toaster.error(resp.error.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  public handleChange($event) {
    this.noteData["a_guantes"] = false;
    this.checksAccions;
    this.accionRadio = $event.target.value;

    this.radioData = {
      [this.accionRadio.split("-")[0]]: true,
    };
  }

  public refresh() {
    this.noteData = {
      i_ant_pac: false,
      i_ant_asept: false,
      i_desp_fc: false,
      i_desp_pac: false,
      i_desp_asept: false,
      a_fm: false,
      a_lm: false,
      a_omision: false,
      a_guantes: false,
    };

    this.radioData = {};
    this.accionRadio = "";
  }

  public changeProfessionalCategory($event) {
    let category = $event.target.value;

    switch (category) {
      case "Enfermería":
        this.listprofessionalProfile =
          this.professionalProfileSelect["Nursing"];
        break;
      case "Medicina":
        this.listprofessionalProfile =
          this.professionalProfileSelect["Medicine"];
        break;
      case "Técnico sanitario":
        this.listprofessionalProfile =
          this.professionalProfileSelect["SanitaryTechnician"];
        break;
      case "Fisioterapia":
        this.listprofessionalProfile =
          this.professionalProfileSelect["Physiotherapy"];
        break;
      case "Odontología":
        this.listprofessionalProfile =
          this.professionalProfileSelect["Odontology"];
        break;
      case "Celador":
        this.listprofessionalProfile =
          this.professionalProfileSelect["Watchman"];
        break;
      case "Otros":
        this.listprofessionalProfile = this.professionalProfileSelect["Others"];
        break;
      default:
    }
    this.code=this.listprofessionalProfile[0];
    
  }
}
